/* global axios */
import ApiClient from '../ApiClient';

class CopilotThreads extends ApiClient {
  constructor() {
    super('captain/copilot_threads', { accountScoped: true });
  }

  // Bir konusmanin copilot sohbetleri. Parametresiz cagri eski
  // davranisi koruyor: kullanicinin son sohbetleri.
  get({ conversationId, page } = {}) {
    return axios.get(this.url, {
      params: { conversation_id: conversationId, page },
    });
  }
}

export default new CopilotThreads();
